import { useState, useEffect } from 'react'

const useOverflow = (ref) => {
    const [overflow, setOverflow] = useState(false)

    useEffect(() => {
        const el = ref.current
        if (!el) return
        const check = () => setOverflow(el.scrollHeight > el.clientHeight)
        check()
        const observer = new ResizeObserver(check)
        observer.observe(el)
        return () => observer.disconnect()
    }, [ref])

  return overflow
}
export default useOverflow